import { apiFetch } from '@/lib/api-client';
import type { BillingSummary } from '@/lib/billing/billing-summary';

export interface CheckoutSessionResult {
  url: string;
  sessionId: string;
}

export interface VerifyCheckoutSessionResult {
  success?: boolean;
  ready: boolean;
  subscriptionId?: string;
}

export async function createCheckoutSessionApi(priceId: string): Promise<CheckoutSessionResult> {
  return apiFetch<CheckoutSessionResult>('/billing/checkout-session', {
    method: 'POST',
    body: JSON.stringify({ priceId }),
  });
}

export async function verifyCheckoutSessionApi(
  sessionId: string
): Promise<VerifyCheckoutSessionResult> {
  return apiFetch<VerifyCheckoutSessionResult>('/billing/verify-checkout-session', {
    method: 'POST',
    body: JSON.stringify({ sessionId }),
  });
}

export async function getMyBillingSummaryApi(): Promise<BillingSummary> {
  return apiFetch<BillingSummary>('/billing/my-subscription');
}

export interface PortalSessionResult {
  url: string;
}

export async function createPortalSessionApi(): Promise<PortalSessionResult> {
  return apiFetch<PortalSessionResult>('/billing/portal-session', {
    method: 'POST',
  });
}
